import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class RemovableController extends Controller {
  connect() {
  }

  slideUp(e) {
    const $el = $(this.element)
    $el.slideUp(() => $el.remove())
  }
}
